import { render } from "./Block.vue?vue&type=template&id=3e1b8f1e&scoped=true&ts=true"
import script from "./Block.vue?vue&type=script&lang=ts"
export * from "./Block.vue?vue&type=script&lang=ts"

import "./Block.vue?vue&type=style&index=0&id=3e1b8f1e&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1b8f1e"]])

export default __exports__